<template>
  <ul>
    <li>
      <p :class="{ cur: data.foreignId === $store.state.frameworkId }" @click.stop="selectModule(data)">
        <span style="margin-right: 5px;">
          <i
            v-if="data.children && data.children.length"
            :class="{ 'treelist-arrow-bt': data.expanded, 'treelist-arrow-left': !data.expanded }"
            @click="open(data, index)"
          ></i>
          <i class="treelist-file"></i>
        </span>
        <span v-if="!data.isRename" class="fdd-text-tips tree-list-hide">
          <fdd-tooltip :content="data.name">
            <span class="text-hide">{{ data.name }}</span>
          </fdd-tooltip>
        </span>
        <span v-if="data.isRename" class="edit-input">
          <input v-model.trim="data.name" type="text" maxLength="20" placeholder="请输入文件夹名称" />
          <span class="edit-btn-box">
            <span class="edit-border-btn" @click.stop="rename(data)"><i class="sign-icon-hook"></i></span>
            <span class="edit-border-btn" @click.stop="clearInput(data, index)"><i class="sign-icon-close"></i></span>
          </span>
        </span>
        <i v-if="isOptionsShow && !data.isRename" class="treelist-file-more" @click="displayOptions(data)">...</i>
        <!--默认的下面的菜单是隐藏，点击更多则出现-->
        <span v-if="isOptions" class="treelist-file-more-list">
          <a @click="isRenameInput(data)">重命名</a>
          <a @click="deleteFile(data, index)">删除</a>
        </span>
      </p>
      <template v-for="(item, idx) of data.children">
        <fa-tree-item
          v-if="data.expanded"
          :key="idx"
          :data="item"
          :is-options-show="isOptionsShow"
          :index="idx"
          :is-add="isAdd"
          @selectModule="selectModule"
          @rename="rename"
          @deleteFile="deleteFile"
        ></fa-tree-item>
      </template>
    </li>
  </ul>
</template>
<script>
  import { isSpecial } from '@/utils/validate.js'
  export default {
    name: 'FaTreeItem',
    props: {
      //数据源
      data: {
        type: Object,
        default: () => ({})
      },
      //下标
      index: {
        type: Number,
        default: -1
      },
      //是否为添加
      isAdd: {
        type: Boolean,
        default: false
      },
      //是否显示多操作
      isOptionsShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOptions: false, //是否显示更多操作
        info: {} //保存原有的值
      }
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('click', this.close)
      })
    },
    beforeDestroy() {
      window.removeEventListener('click', this.close)
    },
    methods: {
      //点击展开/收起树形菜单
      open(m, index) {
        m.expanded = !m.expanded
      },
      //暂开多操作
      displayOptions() {
        this.isOptions = !this.isOptions
      },
      //关闭多操作
      close() {
        const e = document.all ? window.event : arguments[0] ? arguments[0] : event
        if (!this.$el.contains(e.target)) {
          this.isOptions = false
        }
      },
      //是否唤起文本框
      isRenameInput(m) {
        this.info = JSON.parse(JSON.stringify(m))
        this.isAdd = false
        m.isRename = !m.isRename
        this.isOptions = false
      },
      //重命名
      rename(m) {
        if (m.name === '') {
          this.$warning('文件夹名称不能为空')
          return
        } else if (!isSpecial(m.name)) {
          this.$warning('文件夹名称不能为特殊字符')
          return
        }
        //m.isRename=false;
        if (this.isAdd) {
          m.isAdd = true
        } else {
          m.isAdd = false
        }
        this.$emit('rename', m)
      },
      //取消
      clearInput(m, index) {
        event.stopPropagation()
        if (this.isAdd) {
          m.index = index
          this.$emit('clearInput', m)
        } else {
          m.name = this.info.name
        }
        m.isRename = false
      },
      //删除文件夹
      deleteFile(list, index) {
        this.$emit('deleteFile', list)
      },
      //获取选中的数据
      selectModule(list) {
        this.$store.commit('selectFrameworkId', list.id)
        this.$emit('selectModule', list)
      }
    }
  }
</script>
